import { Component, OnInit, OnDestroy } from "@angular/core";
//import { Subscription } from 'rxjs';

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { UserService } from "../../../shared/services/user.service";

import { DataService_photoexport } from "./shared/data.service";
import { SchoolInfo } from "./shared/SchoolInfo";
import { wsPhotoExportStudentGroupInfo } from "./shared/wsPhotoExportStudentGroupInfo";
import { wsPhotoExportStudentParm } from "./shared/wsPhotoExportStudentParm";
import { wsPhotoExportStaffParm } from "./shared/wsPhotoExportStaffParm";
import { wsPhotoExportZipInfo } from "./shared/wsPhotoExportZipInfo";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { ExportMapFileDialogComponent } from "./export-map-file-dialog/export-map-file-dialog.component";

@Component({
	selector: "app-root",
	templateUrl: "./photoexport.component.html",
	styleUrls: ["./photoexport.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class PhotoExportComponent implements OnInit, OnDestroy {
	constructor(
		private selectService: SchoolselectorService,
		private dataService: DataService_photoexport,
		private userService: UserService,
		private schoolService: SchoolService,
		private confirmationService: ConfirmationService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private user: any;
	public isBusy: boolean = false;
	public isStudentDownloadBusy = false;
	public isStaffDownloadBusy = false;
	public StudentMessage: string = "";
	public StaffMessage: string = "";

	//	School Selector
	public PreSelectSchoolID: any = -1; // -1 = [no selection]
	public lstSchool: any = [];
	public SelectedSchool: SchoolInfo;

	//	StudentGroup Selector
	public lstStudentGroup: wsPhotoExportStudentGroupInfo[] = [];
	public SelectedStudentGroup: wsPhotoExportStudentGroupInfo;

	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "- Select a School -";

	SchoolDownloadRequests: number = -1;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.lstStudentGroup = [];
		this.lstStudentGroup.unshift({
			GroupID: -1,
			GroupName: "- ALL STUDENTS -",
		});

		this.SelectedStudentGroup = this.lstStudentGroup[0];

		// this.LoadSchoolList();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExportStudentPhoto
	//
	//-----------------------------------------------------------------------------------------------------
	onExportStudentPhoto() {
		if (this.SelectedSchool.SchoolID > 0) {
			let parms: wsPhotoExportStudentParm = {
				SchoolID: this.SelectedSchool.SchoolID,
				GroupID: this.SelectedStudentGroup.GroupID,
			};

			//
			//	Request Student Photos
			//
			this.isStudentDownloadBusy = true;
			this.StudentMessage = "Downloading Student Photos. Please wait...";
			this.dataService.PhotoExportStudent(parms).subscribe((data) => this.PhotoExportStudent_Callback(data));
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a school.",
				header: "School not selected",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportStudent_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	async PhotoExportStudent_Callback(blob: any) {
		//
		//	Callback recieves the JSON response as a blob (like a raw file)
		//		(HTTP Client JSON parser errors most of the time around 50mb)
		//

		//
		//	Manually read the blob into a JSON object
		//
		var data = JSON.parse(await blob.text());

		this.isStudentDownloadBusy = false;

		var lstPhotoExportZip: wsPhotoExportZipInfo[] = [];

		//
		//	Take the Result of the ResponseModel
		//
		lstPhotoExportZip = data.result;

		if (lstPhotoExportZip == undefined || lstPhotoExportZip.length == 0) {
			this.StudentMessage = "Error exporting photos. Please try again or contact support.";
		} else {
			if (lstPhotoExportZip[0].RequestsLeft <= 0) {
				this.StudentMessage =
					"You have reached the maximum download requests of " + lstPhotoExportZip[0].MaxRequests + " per day. Please try again tomorrow.";
			} else {
				if (lstPhotoExportZip[0].ZipBase64 == "") {
					this.StudentMessage =
						"No student photos in CAASS for the selected school/group. You have " +
						lstPhotoExportZip[0].RequestsLeft +
						" download requests left for today.";
				} else {
					const dlink: HTMLAnchorElement = document.createElement("a");
					dlink.download = lstPhotoExportZip[0].ZipFileName;

					//
					//	B64 links don't work as well when the file is very large
					//	Take the Zip B64, and make it into a blob/raw file
					//	Then create an ObjectURL to that blob and download it
					//
					var zipBlob = this.base64toBlob(lstPhotoExportZip[0].ZipBase64, "application/zip");
					dlink.href = window.URL.createObjectURL(zipBlob);

					dlink.click();
					dlink.remove();

					this.StudentMessage =
						"Student photo download complete. You have " +
						lstPhotoExportZip[0].RequestsLeft +
						" download requests left for today. Your browser will prompt the save file shortly. Please wait...";
				}
			}
		}

		this.dataService.PhotoExportPreferencesSelect(this.SelectedSchool.SchoolID).subscribe((data) => this.PhotoExportPreferencesSelect_Complete(data));
	}

	base64toBlob(base64Data, contentType) {
		contentType = contentType || "";
		var sliceSize = 1024;
		var byteCharacters = atob(base64Data);
		var bytesLength = byteCharacters.length;
		var slicesCount = Math.ceil(bytesLength / sliceSize);
		var byteArrays = new Array(slicesCount);

		for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
			var begin = sliceIndex * sliceSize;
			var end = Math.min(begin + sliceSize, bytesLength);

			var bytes = new Array(end - begin);
			for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
				bytes[i] = byteCharacters[offset].charCodeAt(0);
			}
			byteArrays[sliceIndex] = new Uint8Array(bytes);
		}
		return new Blob(byteArrays, { type: contentType });
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExportStaffPhoto
	//
	//-----------------------------------------------------------------------------------------------------
	onExportStaffPhoto() {
		if (this.SelectedSchool.SchoolID > 0) {
			let parms: wsPhotoExportStaffParm = {
				SchoolID: this.SelectedSchool.SchoolID,
			};

			//
			//	Request Staff Photos
			//
			this.isStaffDownloadBusy = true;
			this.StaffMessage = "Downloading Staff Photos. Please wait...";
			this.dataService.PhotoExportStaff(parms).subscribe((data) => this.PhotoExportStaff_Callback(data));
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a school.",
				header: "School not selected",
				icon: "fa fa-info",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportStaff_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	async PhotoExportStaff_Callback(blob: any) {
		//
		//	Callback recieves the JSON response as a blob (like a raw file)
		//		(HTTP Client JSON parser errors most of the time around 50mb)
		//

		//
		//	Manually read the blob into a JSON object
		//
		var data = JSON.parse(await blob.text());

		this.isStaffDownloadBusy = false;

		var lstPhotoExportZip: wsPhotoExportZipInfo[] = [];

		//
		//	Take the Result of the ResponseModel
		//
		lstPhotoExportZip = data.result;

		if (lstPhotoExportZip == undefined || lstPhotoExportZip.length == 0) {
			this.StaffMessage = "Error exporting photos. Please try again or contact support.";
		} else {
			if (lstPhotoExportZip[0].RequestsLeft <= 0) {
				this.StaffMessage =
					"You have reached the maximum download requests of " + lstPhotoExportZip[0].MaxRequests + " per day. Please try again tomorrow.";
			} else {
				if (lstPhotoExportZip[0].ZipBase64 == "") {
					this.StaffMessage =
						"No staff photos in CAASS for the selected school. You have " +
						lstPhotoExportZip[0].RequestsLeft +
						" download requests left for today.";
				} else {
					const dlink: HTMLAnchorElement = document.createElement("a");
					dlink.download = lstPhotoExportZip[0].ZipFileName;

					//
					//	B64 links don't work as well when the file is very large
					//	Take the Zip B64, and make it into a blob/raw file
					//	Then create an ObjectURL to that blob and download it
					//
					var zipBlob = this.base64toBlob(lstPhotoExportZip[0].ZipBase64, "application/zip");
					dlink.href = window.URL.createObjectURL(zipBlob);

					dlink.click();
					dlink.remove();

					this.StaffMessage =
						"Staff photo download complete. You have " +
						lstPhotoExportZip[0].RequestsLeft +
						" download requests left for today. Your browser will prompt the save file shortly. Please wait...";
				}
			}
		}

		this.dataService.PhotoExportPreferencesSelect(this.SelectedSchool.SchoolID).subscribe((data) => this.PhotoExportPreferencesSelect_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadSchoolList
	//
	//-----------------------------------------------------------------------------------------------------
	LoadSchoolList() {
		var result = this.schoolService.loadSchoolList("");

		result.subscribe(
			(response) => {
				this.lstSchool = response;
				let isItemFound: boolean = false;
				let isSchoolSelected: boolean = false;

				//
				//	Add the [- Select a school -] to the top of the list
				//
				//	Note: "- Select a school" is put in SchoolNumber to match the HTML formatting.
				//		this allows it to show with a visual appeal that matches the rest of the items.
				//
				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "- Select a school",
					SchoolName: "",
				});

				//
				//	if PreSelectSchoolID has a value not equal -1 then try to select the item
				//
				this.lstSchool.forEach((item) => {
					if (this.PreSelectSchoolID == item.SchoolID && isItemFound == false && this.PreSelectSchoolID != -1) {
						this.SelectedSchool = item;
						isItemFound = true;
						isSchoolSelected = true;
					}
				});

				//
				//	if PreSelectSchoolID was not found
				//
				if (isItemFound == false) {
					//
					//	If there is only 1 school in list and (PreSelectSchoolID = -1 or PreSelectSchoolID matched the school)
					//	then select it. otherwise select the [- Select a School -] item.
					//
					if (this.lstSchool.length == 2) {
						if (this.PreSelectSchoolID == -1 || this.PreSelectSchoolID == this.lstSchool[1].SchoolID) {
							this.SelectedSchool = this.lstSchool[1];
							isSchoolSelected = true;
						} else {
							this.SelectedSchool = this.lstSchool[0];
						}
					} else {
						this.SelectedSchool = this.lstSchool[0];
					}
				}

				this.isBusy = false;
				this.isStudentDownloadBusy = false;
				this.isStaffDownloadBusy = false;
				this.StudentMessage = "";
				this.StaffMessage = "";

				if (isSchoolSelected == true) {
					this.isBusy = true;
					this.StudentMessage = "";
					this.StaffMessage = "";
					this.dataService.StudentGroupsSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.StudentGroupsSelectList_Complete(data));
				}
			},
			(error) => {}
		);
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSchoolChange
	//
	//-----------------------------------------------------------------------------------------------------
	onSchoolChange(value) {
		this.SelectedSchool = value;

		if (this.SelectedSchool.SchoolID > 0) {
			this.isBusy = true;
			this.StudentMessage = "";
			this.StaffMessage = "";
			this.dataService.StudentGroupsSelectList(this.SelectedSchool.SchoolID).subscribe((data) => this.StudentGroupsSelectList_Complete(data));
			this.dataService.PhotoExportPreferencesSelect(this.SelectedSchool.SchoolID).subscribe((data) => this.PhotoExportPreferencesSelect_Complete(data));
		} else {
			this.lstStudentGroup = [];
			this.lstStudentGroup.unshift({
				GroupID: -1,
				GroupName: "- ALL STUDENTS -",
			});

			this.SelectedStudentGroup = this.lstStudentGroup[0];

			this.isBusy = false;
			this.isStudentDownloadBusy = false;
			this.isStaffDownloadBusy = false;
			this.StudentMessage = "";
			this.StaffMessage = "";
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	StudentGroupsSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	onStudentGroupChange(value) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	StudentGroupsSelectList_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	StudentGroupsSelectList_Complete(data: any) {
		this.lstStudentGroup = data;

		this.lstStudentGroup.unshift({
			GroupID: -1,
			GroupName: "- ALL STUDENTS -",
		});

		this.SelectedStudentGroup = this.lstStudentGroup[0];

		this.isBusy = false;
		this.isStudentDownloadBusy = false;
		this.isStaffDownloadBusy = false;
		this.StudentMessage = "";
		this.StaffMessage = "";
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportPreferencesSelect_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoExportPreferencesSelect_Complete(data: any) {
		this.SchoolDownloadRequests = data.DownloadRequestsLeft;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onResetDonwloadRequests
	//
	//-----------------------------------------------------------------------------------------------------
	onResetDonwloadRequests() {
		this.dataService
			.PhotoExportResetDonwloadRequests(this.SelectedSchool.SchoolID)
			.subscribe((data) => this.PhotoExportResetDonwloadRequests_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoExportResetDonwloadRequests_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoExportResetDonwloadRequests_Complete(data: any) {
		//Success Dialog
		this.confirmationService.confirm({
			acceptLabel: "Ok",
			rejectVisible: false,
			message: "Today's download limit was reset for school " + this.SelectedSchool.SchoolNumber + "-" + this.SelectedSchool.SchoolName + ".",
			header: "Success",
			icon: "fa",
			accept: () => {},
		});
		this.dataService.PhotoExportPreferencesSelect(this.SelectedSchool.SchoolID).subscribe((data) => this.PhotoExportPreferencesSelect_Complete(data));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	IsSU
	//
	//-----------------------------------------------------------------------------------------------------
	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExportStudentMap
	//		Opens dialog to create text file with exported file names
	//
	//-----------------------------------------------------------------------------------------------------
	onExportStudentMap() {
		if (this.SelectedSchool == undefined || this.SelectedSchool.SchoolID == undefined || this.SelectedSchool.SchoolID <= 0) {
			return;
		}

		var ref = this.dialogService.open(ExportMapFileDialogComponent, {
			header: "Export Student Map File",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				Mode: "Student",
				SelectedSchool: this.SelectedSchool,
				SelectedStudentGroup: this.SelectedStudentGroup,
			},
		});
		ref.onClose.subscribe((response) => {});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExportStaffMap
	//		Opens dialog to create text file with exported file names
	//
	//-----------------------------------------------------------------------------------------------------
	onExportStaffMap() {
		if (this.SelectedSchool == undefined || this.SelectedSchool.SchoolID == undefined || this.SelectedSchool.SchoolID <= 0) {
			return;
		}

		var ref = this.dialogService.open(ExportMapFileDialogComponent, {
			header: "Export Staff Map File",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				Mode: "Staff",
				SelectedSchool: this.SelectedSchool,
			},
		});
		ref.onClose.subscribe((response) => {});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
